<template>
  <span class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium leading-5"
    :class="{
      ' bg-green-100 text-green-800': isActive,
      'bg-red-100 text-red-800': isExpired,
      'bg-yellow-100 text-yellow-800': isScheduled,
    }"
  >
    {{ status | name }}
  </span>
</template>

<script>
import DiscountStatus from "@/data/discountStatuses.js";

export default {
  name: "DiscountStatus",
  filters: {
    name: DiscountStatus.getName
  },
  props: {
    status: {
      type: String,
      required: true
    }
  },
  computed: {
    isActive() {
      return this.status === DiscountStatus.Active;
    },
    isExpired() {
      return this.status === DiscountStatus.Expired;
    },
    isScheduled() {
      return this.status === DiscountStatus.Scheduled;
    },
  },
};
</script>
